import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import { FormSelectYesNo, FormSelectYesNoFile, FormInputText, DateSelector, FormTextArea } from '../formelements'


export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authPublicacions, setAuthPublicacions ] = useState(false);
  const [authMaterial, setAuthMaterial ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);
  const [authGDPR, setAuthGDPR] = useState("0");
  const [authSortides, setAuthSortides ] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {

    let d = {
     "validat": noError,
  
    /* DADES AUTORITZACIONS */
    "authIntranet": authIntranet,
    "authPublicacions": authPublicacions,
    "authMaterial": authMaterial,
    "authInternet": authInternet,
    "authGDPR": authGDPR
    }
  
      console.log("DADES_AUTORITZACIONS",d)
      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }

  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions= () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial= () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthInternet= () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

 const handleChangeSortides = (t) => {

      setAuthSortides(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
}


 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }



/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authIntranet = validaAuthIntranet();
  handleErrors('authIntranet',error)

  error.authPublicacions = validaAuthPublicacions();
  handleErrors('authPublicacions',error)

  error.authMaterial = validaAuthMaterial();
  handleErrors('authMaterial',error)

  error.authInternet = validaAuthInternet();
  handleErrors('authInternet',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  setErrors(error)

  let noError = true;
  //DEVELOP 
  Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )

  console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}


/*
useEffect(() => {

   validaAutoritzacions()

},[authGDPR])
*/



  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">
                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Autorització relativa a l’alumnat major de
                                      14 anys i del personal docent i no docent
                                      del centre: ús d’imatges, publicació de
                                      dades de caràcter personal i de material
                                      que elaboren. Curs {props.enguany}-
                                      {props.anyVinent}
                                    </h4>
                                    <p>
                                      El centre disposa d’espais de comunicació
                                      i difusió, inclosos els espais web (adreça
                                      o adreces web), on informa i fa difusió de
                                      les activitats escolars lectives,
                                      complementàries i extraescolars. En
                                      aquests espais es poden publicar
                                      imatges/veu en què aparegui,
                                      individualment o en grup, alumnat i
                                      personal docent que fa les activitats
                                      esmentades. El dret a la pròpia imatge és
                                      reconegut en l’article 18.1 de la
                                      Constitució espanyola i està regulat per
                                      la Llei orgànica 1/1982, de 5 de maig,
                                      sobre el dret a l’honor, a la intimitat
                                      personal i familiar i a la pròpia imatge,
                                      per la qual cosa la direcció d’aquest
                                      centre demana el consentiment per publicar
                                      fotografies i vídeos on surti alumnat i
                                      personal docent que hi sigui clarament
                                      identificable.
                                    </p>

                                    <p>
                                      Autoritzo mentre mantingui vinculació amb
                                      el centre
                                    </p>

                                    <p>
                                      1. Que la meva imatge/veu pugui sortir en
                                      fotografies i/o vídeos corresponents a
                                      activitats escolars lectives,
                                      complementàries i extraescolars
                                      organitzades pel centre i publicades en: -
                                      En webs del centre:
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <FormSelectYesNo
                                      id="authIntranet"
                                      name="authIntranet"
                                      col="col-4"
                                      label="Intranet amb accés restringit:"
                                      obligatori={true}
                                      value={authIntranet}
                                      handleChange={(e) => setAuthIntranet(e.target.value) }
                                      error={errors.authIntranet}
                                    />

                                    <FormSelectYesNo
                                      id="authPublicacions"
                                      name="authPublicacions"
                                      col="col-4"
                                      label="Publicacions del centre"
                                      obligatori={true}
                                      value={authPublicacions}
                                      handleChange={(e) => setAuthPublicacions(e.target.value) } 
                                      error={errors.authPublicacions}
                                    />

                                    <FormSelectYesNo
                                      id="authInternet"
                                      name="authInternet"
                                      col="col-4"
                                      label="Internet amb accés no restringit"
                                      obligatori={true}
                                      value={authInternet}
                                      handleChange={(e) => setAuthInternet(e.target.value) } 
                                      error={errors.authInternet}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <p>
                                      2. Que el material que elabori pugui ser publicat en els espais de comunicació
                                      (blogs i espais web i revistes) del mateix centre amb la finalitat de desenvolupar
                                      l’activitat educativa:
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col col-12 ">

                                    <FormSelectYesNo
                                      id="authMaterial"
                                      name="authMaterial"
                                      col="col-4"
                                      label="Autoritzo"
                                      obligatori={true}
                                      value={authMaterial}
                                      handleChange={(e) => setAuthMaterial(e.target.value) } 
                                      error={errors.authMaterial}
                                    />
                                  </div>
                                </div>

                                      <br/>

                                { props.dadesPersonals.edat < 18 ? (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització per a realitzar activitats fora del centre
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authSortides" name="authSortides" value={authSortides} checked={authSortides === "1" ? true : false } onChange={ (t) => { handleChangeSortides(t.target.value) } } required/>
                                      <label htmlFor="authSortides">
                                        AUTORITZO a l'alumne/a matriculat/ada a:
                                        <ul>
                                          <li>participar en totes les activitats i sortides formatives fora del centre.</li>
                                          <li>desplaçar-se/tornar pel seu compte fins a/des d'un punt de trobada preestablert en
                                          activitats o sortides fora del centre.</li>
                                          {/*<li>a sortir sol/a del recinte escolar (Institut, Torre Mossèn Homs o Escola Mpal. d'Art) un cop
                                          acabades les activitats lectives, a l'hora del descans o bé per motius 
                                          excepcionals com canvis d'horari, prohibició d'entrar a classe per arribada amb
                                          retard o no portar el material o uniforme adequats.</li> */}
                                        </ul>

                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>
                                    </p>

                                  </div>
                                </div>) : (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Responsabilització sortides
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authSortides" name="authSortides" value={authSortides} checked={authSortides === "1" ? true : false } onChange={ (t) => { handleChangeSortides(t.target.value) } } required/>
                                      <label htmlFor="authSortides"> Em RESPONSABILITZO dels desplaçaments que faci pel meu compte cap/des de punts preestablerts en activitats i sortides del centre.  </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>
                                    </p>

                                  <br/>

                                  </div>
                                </div>)
                                }

                                      <br/>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Informació bàsica sobre protecció de dades
                                    </h4>
                                    <p>
                                      <b>Responsable del tractament:</b> Direcció del centre educatiu.<br/>
                                      <b>Finalitat:</b> Autorització difusió d’imatge/veu i material elaborat als espais de comunicació i difusió del centre.<br/>
                                      <b>Legitimació:</b> Consentiment de l’interessat o de la persona que ostenta la tutoria legal en cas de menors d’edat.<br/>
                                      <b>Destinataris:</b> Les dades no es comunicaran a tercers, excepte en els casos previstos per llei, o si ho heu consentit
                                      prèviament.<br />
                                      <b>Drets:</b> Accedir a les dades, rectificar-les, suprimir-les, oposar-se al tractament i sol·licitar-ne la limitació.<br />
                                      <b>Informació addicional:</b> Podeu consultar la informació addicional i detallada sobre protecció de dades a la pàgina:
                                    </p>
                                      <ul>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament" target="_blank">https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament</a> </li>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/personal-centres-departament" target="_blank">https://educacio.gencat.cat/ca/Detall/personal-centres-departament</a></li>
                                      </ul>
                                    <br/>

                                    <p>
                                      <input type="checkbox" id="authGDPR" name="authGDPR" value={authGDPR} checked={authGDPR === "1" ? true : false } onChange={ (t) => { handleChangeGDPR(t.target.value) } } required/>
                                      <label for="authGDPR">He llegit la informació bàsica sobre protecció de dades i autoritzo el tractament de les meves dades personals.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authGDPR}</span>
                                    </p>

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>




                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}